<template>
  <AuthComponent />
</template>

<script>
import AuthComponent from "@/components/AuthComponent";

export default {
  components: {
    AuthComponent,
  },
};
</script>